<template>
    <div>
        <v-container fluid grid-list-sm>
            <v-row>
                <v-col cols="12" sm="9">
                    <v-btn @click="connectQb" text large width="200" >
                        <v-img contain width="200" :src="require('../../assets/IntuitSignIn-lg-white@2x.jpg')" />
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="9">
                    <h3 class="display-1 primary--text">Events</h3>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-btn @click="$store.dispatch('admin/setManageEventDialog', true)" x-large class="float-right" color="primary" fab icon><v-icon>mdi-pencil</v-icon></v-btn>
                </v-col>
                <v-col cols="12" sm="12">
                    <v-data-table :headers="eventHeaders" :items="events" class="elevation-1 mt-5">
                        <template v-slot:item.startDate="{item}">
                            <span> {{ item.startDate | moment('DD/MM/YYYY') }} </span>
                        </template>
                        <template v-slot:item.endDate="{item}">
                            <span> {{ item.endDate | moment('DD/MM/YYYY') }} </span>
                        </template>
                        <template v-slot:item.actions="{item}">
                            <v-btn large icon @click="deleteEvent(item)" :loading="deletingEvent" :disabled="deletingEvent">
                                <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="9">
                    <h3 class="display-1 primary--text">Notes</h3>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-btn @click="$store.dispatch('admin/setManageNoteDialog', true)" x-large class="float-right" color="primary" fab icon><v-icon>mdi-pencil</v-icon></v-btn>
                </v-col>
                <v-col cols="12" sm="12">
                    <v-data-table :headers="noteHeaders" :items="notes" class="elevation-1 mt-5">
                        <template v-slot:item.actions="{item}">
                            <v-btn @click="deleteNote(item)" :loading="deletingNote" :disabled="deletingNote" large icon>
                                <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import {NotesHttp} from "../../http/notes";
    import {EventsHttp} from "../../http/events";
    import {EventBus} from "../../EventBus";


    export default {
        name: "Admin",
        methods: {
            async deleteNote(item) {
                this.deletingNote = true;
                await NotesHttp.deleteNotes(item._id);
                await this.$store.dispatch('admin/setNotes');
                this.deletingNote = false;
                EventBus.$emit('message', {message: 'Note deleted', type: 'success'});
            },
            async deleteEvent(item) {
                this.deletingEvent = true;
                await EventsHttp.deleteEvent(item._id);
                await this.$store.dispatch('admin/setEvents');
                this.deletingEvent = false;
                EventBus.$emit('message', {message: 'Event deleted', type: 'success'});
            },
            connectQb() {
                window.location.href = '/api/qb/auth'
            }
        },
        data() {
            return {
                eventHeaders: [
                    { text: 'Name', value: 'name' },
                    { text: 'Start', value: 'startDate' },
                    { text: 'End', value: 'endDate' },
                    { text: 'Actions', value: 'actions', sortable: false }
                ],
                noteHeaders: [
                    { text: 'Name', value: 'name' },
                    { text: 'Actions', value: 'actions', sortable: false }
                ],
                deletingNote: false,
                deletingEvent: false
            }
        },
        computed: {
            events: {
                get() {
                    return this.$store.state.admin.events;
                }
            },
            notes: {
                get() {
                    return this.$store.state.admin.notes;
                }
            }
        }
    }
</script>

<style scoped>

</style>
